import React from 'react';
import { SERVICE_DESK_PROJECT } from '@atlassian/jira-common-constants/src/project-types';
import withInjectedProps from '@atlassian/jira-common-util-with-injected-props';
import { DocumentTitle as DocumentTitleDI } from '@atlassian/jira-global-document-title/src';
import { injectIntlV2 as injectIntl } from '@atlassian/jira-intl/src/v2/inject.tsx';
import { PageTitle as ServiceDeskPageTitle } from '@atlassian/jira-servicedesk-spa-commons/src/common/utils/document-title';
import messages from './messages';
import type { Props } from './types';

export const PageTitle = (props: Props) => {
	const {
		DocumentTitle,
		section,
		action,
		intl: { formatMessage },
		projectName,
		projectType,
	} = props;

	if (projectType === SERVICE_DESK_PROJECT) {
		return (
			<ServiceDeskPageTitle
				DocumentTitle={DocumentTitle}
				section={section}
				intl={props.intl}
				projectName={projectName}
			/>
		);
	}

	const actionTitle = action && formatMessage(messages[action]);
	// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ proformaForms: MessageDescriptorV2; connectAppControls: MessageDescriptorV2; features: MessageDescriptorV2; ... 6 more ...; toolchain: MessageDescriptorV2; }'.
	const sectionTitle = formatMessage(messages[section]);

	const title = actionTitle
		? `${actionTitle} - ${projectName} - ${sectionTitle}`
		: `${projectName} - ${sectionTitle}`;

	return <DocumentTitle title={title} />;
};

const InjectedPage = withInjectedProps(PageTitle, {
	DocumentTitle: DocumentTitleDI,
});

export const SharedSettingsDocumentTitle = injectIntl(InjectedPage);
export default SharedSettingsDocumentTitle;
